import { useMainStore } from "~/store/mainState";
import { useRegionStore } from "~/store/regionStore";

export default defineNuxtPlugin(nuxtApp => {

    if (!('geolocation' in navigator)) {
        return;
    }

    const mainStore = useMainStore();
    const regionStore = useRegionStore();
    // if (!mainStore.shouldAskGeo) {
    //     regionStore.awaitingGeo = false;
    //     return;
    // }

    navigator.geolocation.getCurrentPosition(async (position) => {
        if (position.coords) {
            regionStore.useCoords(position.coords.longitude, position.coords.latitude);
        } else {
            regionStore.awaitingGeo = false;
        }
    }, () => {
        regionStore.awaitingGeo = false;
    })
});